function GetCalculationDependencies(inputs) {
  const base_inputs_condition = [
    'h1',
    'machine_type',
    ...(inputs.sv_family === 'SV-L' ? [] : [inputs.h3 > 0 ? 'h3' : 'h2']),
    'configuration',
  ];
  if (inputs.sv_family === 'SVm') base_inputs_condition.push('track');
  const calculationDependencies = [
    {
      conditions: [
        'h1',
        'h2',
        ...(inputs.sv_family === 'SV-L' ? ['machine_type'] : []),
      ],
      calculation: ['h3'],
    },
    {
      conditions: [
        'h1',
        'h3',
        ...(inputs.sv_family === 'SV-L' ? ['machine_type'] : []),
      ],
      calculation: ['h2'],
    },
    {
      conditions: base_inputs_condition,
      calculation: [
        'configuration_angle',
        'column_centre_to_inside_windings',
        'nbr_windings',
        'central_diam',
        'belt_width',
        'column_diameter',
        'nbr_spoke',
        'spoke_diameter',
        'winding_thickness',
        'slope_angle_le',
        'slope_angle_center',
        'l1',
        'u1',
        'u1_extension',
        'l1_extension',
        'floor_support_le',
        'floor_support_rc',
        'pitch',
        'u2',
        'l2',
        'u2_value',
        'l2_value',
        'ue_angular',
        'le_angular',
        'ue_double_bend_value',
        'le_double_bend_value',
        'horizontal_clearance',
        'column_centre_to_inside_outer_guide',
        'column_centre_to_inside_le',
        'column_centre_to_inside_ue',
        'outside_guide_thickness',
        'inside_guide_thickness',
        'default_guide_thickness',
        'le_horizontal_clearance',
        'ue_horizontal_clearance',
        'windings_horizontal_clearance',
        'le_vertical_clearance',
        'pitch_clearance',
        'ue_vertical_clearance',
        'product_vertical_clearance',
        'vertical_clearance_without_product',
        'horizontal_clearance_without_product',
        'closure_gap_option',
        'qr_code_1mm',
        'outside_diameter',
        'footprint_diameter',
        'product_max_length',
        'gear_motor_type_calculated',
        'product_min_width',
        'product_min_length',
        'minimum_column_top_extension',
        'mounting_brackets_outer_diam',
        'recommended_max_slope_angle',
        'min_distance_split_above_le',
        'max_distance_split_above_le',
        'distance_centre_rc_j_config',
        ...(['SV', 'SVs'].includes(inputs.sv_family)
          ? [
              'nbr_bracing',
              'transport_length',
              'transport_width',
              'transport_height',
              'transport_weight',
              'transport_dimensions',
            ]
          : []),
        ...(inputs.sv_family === 'SV-L'
          ? [
              'h2',
              'h3',
              'digital_manual_en',
              'english_manual',
              'ambaflex_sticker',
            ]
          : ['return_channel_thickness']),
        'price',
      ],
    },
    {
      conditions: [
        ...base_inputs_condition,
        'belt_guide',
        'chain_material',
        inputs.speed_range !== 'customized'
          ? 'speed_range'
          : 'centerline_speed',
      ],
      calculation: [
        'torques',
        'min_required_torque',
        'torque_rating',
        'track_length',
        'total_product_weight',
        'max_total_load',
        'product_load_line',
        'max_allowed_load_line',
        'filling_rate_percent',
        'critical_filling_rate_percent',
        'filling_rate',
        'critical_filling_rate_center',
        'critical_filling_rate_outside',
        'all_product_load',
        'brake',
      ],
    },
    {
      conditions:
        inputs.sv_family === 'SVs'
          ? [
              ...base_inputs_condition,
              inputs.speed_range !== 'customized'
                ? 'speed_range'
                : 'centerline_speed',
            ]
          : [],
      calculation: inputs.sv_family === 'SVs' ? ['banking_angle'] : [],
    },
    inputs.speed_range !== 'customized'
      ? { conditions: ['speed_range'], calculation: ['centerline_speed'] }
      : { conditions: [], calculation: [] },
    {
      conditions: [
        ...base_inputs_condition,
        ...(inputs.sv_family === 'SV-L'
          ? []
          : ['slat_type', 'transport_direction', 'friction_type']),
        inputs.speed_range !== 'customized'
          ? 'speed_range'
          : 'centerline_speed',
      ],
      calculation: ['machine_code', 'drive_list', 'drive_information'],
    },
    {
      conditions: [
        ...base_inputs_condition,
        'drive_region',
        'gearmotor_type',
        'motor_mounting_position',
      ],
      calculation: ['gearmotor_shaft_length', 'motor_mounting'],
    },
    {
      conditions: [...base_inputs_condition, 'drive'],
      calculation: ['motor_clearance', 'drive_type'],
    },
    {
      conditions: [...base_inputs_condition, 'number_pdp'],
      calculation: ['max_angle_center'],
    },
    {
      conditions: [...base_inputs_condition, 'connection_conveyor'],
      calculation: [
        'connection_conveyor_height',
        'connection_conveyor_mdb_code',
      ],
    },
  ];
  return calculationDependencies;
}

export default GetCalculationDependencies;
